import { render, staticRenderFns } from "./ImportStatusBox.vue?vue&type=template&id=1960cd63&"
import script from "./ImportStatusBox.vue?vue&type=script&lang=js&"
export * from "./ImportStatusBox.vue?vue&type=script&lang=js&"
import style0 from "./ImportStatusBox.vue?vue&type=style&index=0&id=1960cd63&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports